import { render, staticRenderFns } from "./CommunicateContent.vue?vue&type=template&id=70566ffb&"
import script from "./CommunicateContent.vue?vue&type=script&lang=js&"
export * from "./CommunicateContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports